import { render, staticRenderFns } from "./NewAssets.vue?vue&type=template&id=03dc52a8&scoped=true&"
import script from "./NewAssets.vue?vue&type=script&lang=js&"
export * from "./NewAssets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dc52a8",
  null
  
)

export default component.exports